import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function RequireAuth({ children }) {
  const { token, syncing } = useAuth();
  if (syncing) return null;
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export function RequireProject({ children }) {
  const { token, project, syncing } = useAuth();
  if (syncing) return null;
  if (!token)   return <Navigate to="/login"    replace />;
  if (!project) return <Navigate to="/projects" replace />;
  return children;
}
